<template>
  <div class="">
    <div class="slider">
      <div class="container">
        <div class="callbacks_container">
          <swiper
            :options="swiperOption"
            class="swiper_Content"
            v-if="bannerList.length > 0"
          >
            <swiper-slide
              v-for="item of bannerList"
              :key="item.id"
              class="rslides"
              id="sliderIntro"
            >
              <img :src="application.imageHost + item.imagePath" />
            </swiper-slide>
            <div class="swiper-pagination1" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="companyIntro">
      <!-- tab选项 -->
      <div class="solution-tab-content">
        <div
          class="solution-tab"
          :class="active == 0 ? 'isActive' : ''"
          @click="changeTab(0)"
        >
          公司介绍
        </div>
        <div
          class="solution-tab"
          :class="active == 1 ? 'isActive' : ''"
          @click="changeTab(1)"
        >
          企业文化
        </div>

        <div
          class="solution-tab"
          :class="active == 2 ? 'isActive' : ''"
          @click="changeTab(2)"
        >
          组织架构
        </div>
        <div
          class="solution-tab"
          :class="active == 3 ? 'isActive' : ''"
          @click="changeTab(3)"
        >
          资质证书
        </div>
      </div>
      <!-- 企业文化 -->
      <div class="e-content" v-show="active == 1">
        <companyCulture></companyCulture>
      </div>

      <!-- 公司介绍 -->
      <div class="company-introduce" v-show="active == 0">
        <div class="module-title">公司介绍</div>
        <div class="about-main">
          <div class="about-left-w3-agile">
            <h4 class="sub-hdng">{{ companyIntro.company }}</h4>
            <h2 class="sub-hdng-time">{{ companyIntro.foundTime }}成立</h2>
            <p class="sub-hdng-line"></p>
            <div class="clearfix"></div>
            <p class="para-w3-agileits height_rem">
              {{ companyIntro.introduce }}
            </p>
            <div class="sub-span">
              <span class="sub-kehu">企业客户</span>
              <span class="sub-kehu-num">{{ companyIntro.customer }}</span>
            </div>
            <div class="sub-span">
              <span class="sub-kehu">企业遍及国家及地区</span>
              <span class="sub-kehu-num">{{ companyIntro.address }}+</span>
            </div>
            <div class="sub-icon-content">
              <div class="sub-icon-content-item" v-for="(item, i) in adverList">
                <img :src="application.imageHost + item.logoPath" />
                <span>{{ item.content }}</span>
              </div>
              <!--        <div class="sub-icon-content-item">-->
              <!--          <img src="../../images/sub_icon.png">-->
              <!--          <span>高性价比</span>-->
              <!--        </div>-->
              <!--        <div class="sub-icon-content-item">-->
              <!--          <img src="../../images/sub_icon.png">-->
              <!--          <span>高性价比</span>-->
              <!--        </div>-->
              <!--        <div class="sub-icon-content-item">-->
              <!--          <img src="../../images/sub_icon.png">-->
              <!--          <span>高性价比</span>-->
              <!--        </div>-->
            </div>
          </div>
          <div class="about-right-agileinfo">
            <div class="about-top">
              <div class="about-inner a1">
                <img
                  :src="
                    companyIntro.detailImg1
                      ? application.imageHost + companyIntro.detailImg1
                      : defultImg
                  "
                />
              </div>
            </div>
            <div class="about-bottom">
              <div class="about-inner a3">
                <img
                  :src="
                    companyIntro.detailImg2
                      ? application.imageHost + companyIntro.detailImg2
                      : defultImg
                  "
                />
              </div>
              <div class="about-inner a4">
                <img
                  :src="
                    companyIntro.detailImg3
                      ? application.imageHost + companyIntro.detailImg3
                      : defultImg
                  "
                />
              </div>

              <!--                    <div class="about-inner a3">-->
              <!--                      <img :src="companyIntro.detailImg2 ? application.imageHost+companyIntro.detailImg2:defultImg">-->
              <!--                    </div>-->
              <!--                    <div class="about-inner a3">-->
              <!--                      <img :src="companyIntro.detailImg3? application.imageHost+companyIntro.detailImg3 :defultImg">-->
              <!--                    </div>-->
            </div>
          </div>
        </div>
      </div>
      <!-- 团队 -->
      <div v-show="active == 2" class="e-content">
        <team></team>
      </div>
      <div v-show="active == 3" class="e-content">
        <!-- 资质证书 -->
        <horner></horner>
      </div>
    </div>
  </div>
</template>
<style src="./companyIntro.css" scoped></style>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import companyCulture from "../company-culture/company-culture.vue";
import team from "../team/team.vue";
import horner from "../horner/horner.vue";
import mixins from "../../common/mixin";
import application from "../../common/application";
export default {
  name: "companyIntro",
  components: {
    swiper,
    swiperSlide,
    companyCulture,
    team,
    horner,
  },
  data: () => ({
    active: 0,
    application: application,
    companyIntro: {},
    adverList: [],
    swiperOption: {
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      pagination: {
        el: ".swiper-pagination1",
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInterRaction: false,
      },
      loop: true,
    },
    bannerList: [],
    defultImg: require("../../images/defult.png"),
  }),
  mixins: [mixins],
  created() {
    if (this.$route.query.type) {
      this.active = this.$route.query.type;
    }
    this.handleCompanyIntro();
    this.handleAdverList();
    this.handleBannerList();
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.query.type) {
          this.active = this.$route.query.type;
        }
        this.handleCompanyIntro();
        this.handleAdverList();
        this.handleBannerList();
      },
      deep: true,
    },
  },
  methods: {
    // 且换选项卡
    changeTab(active) {
      this.active = active;
    },
    //获取轮播图列表
    handleBannerList: function () {
      let data = {
        pageIndex: 0,
        pageSize: 13,
        type: "company",
      };

      this.request({
        url: "/web/banner/list",
        data: data,
        success: (response) => {
          this.bannerList = response.data.records;
          // console.log(this.bannerList)
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
    //获取公司介绍
    handleCompanyIntro() {
      this.request({
        url: "/web/introduce/detail",
        data: {
          id: 8,
        },
        success: (response) => {
          this.companyIntro = response.data;
          this.companyIntro.foundTime = this.formatDate(
            new Date(parseFloat(this.companyIntro.foundTime)),
            "yyyy年MM月dd日"
          );
          this.companyIntro.detailImg1 = this.companyIntro.detailImageList[0]
            ? this.companyIntro.detailImageList[0].filePath
            : "";
          this.companyIntro.detailImg2 = this.companyIntro.detailImageList[1]
            ? this.companyIntro.detailImageList[1].filePath
            : "";
          this.companyIntro.detailImg3 = this.companyIntro.detailImageList[2]
            ? this.companyIntro.detailImageList[2].filePath
            : "";
          // console.log(response.data)
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },

    //获取优势
    handleAdverList() {
      this.request({
        url: "/web/advantage/list",
        data: {
          introduceId: 8,
          pageIndex: 0,
          pageSize: 10,
        },
        success: (response) => {
          this.adverList = response.data.records;
          // console.log(this.adverList)
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
  },
};
</script>

<style >
.swiper-pagination1 {
  position: absolute;
  text-align: center;
  -webkit-transition: 300ms opacity;
  -o-transition: 300ms opacity;
  transition: 300ms opacity;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  z-index: 10;
}
.solution-tab-content .isActive {
  color: #4678ff;
}
.e-content {
  background: #f5f5f5;
}
.module-title {
  margin: 0 !important;
  padding: 80px 0;
}
.e-content {
  padding-bottom: 20px;
  margin-bottom: 30px !important;
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/companyIntro/companyIntro.vue